import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { TermsModal } from '../app/TermsModal';
import { accountService, alertService, lockerService } from '../_services';
import { fetchWrapper, history } from '../_helpers';


import { loadStripe } from '@stripe/stripe-js';
import { useTranslation } from 'react-i18next';
import LocaleContext from '../LocaleContext';
import { Account } from '../account';




function ExtendReservation({ history, match }) {
    const { locale } = useContext(LocaleContext);
    const { reservationId } = match.params;
    const max_days = accountService.configValue['maxDays'];
    const days_array = new Array(max_days);
    for (let i = 1; i <= max_days; i++) {
        days_array[i - 1] = i;
    }

    const [reservation, setReservation] = useState(null);
    const { t } = useTranslation();
    const [showTerms, setShowTerms] = useState(false);
    const [date, setDate] = useState();
    const [days, setDays] = useState(1);
    const [options, setOptions] = useState([]);

    const stripeKey = accountService.configValue['stripePublicKey'];
    const stripePromise = loadStripe(stripeKey);
    const maxRentalDate = accountService.configValue['maxRentalDate'];


    async function fetchData() {
        try {
            const res = await accountService.getActiveReservations();
            const reservation = res.find(r => r.id == Number(reservationId));
            if (reservation) {
                setReservation(reservation);
            }
        } catch (error) {
            console.error("Error fetching reservations: ", error);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    let initialValues = reservation ? {
        extendReservationId: Number(reservationId) || 0,
        area: reservation.area || "",
        lockerType: reservation.lockerType || "",
        startDate: reservation.endDate || "",
        days: 1,
        acceptTerms: false
    } : {
        extendReservationId: 0,
        area: "",
        lockerType: "",
        startDate: "",
        days: 1,
        acceptTerms: false
    };
    function max_date() {
        if (moment(maxRentalDate, "YYYY-MM-DD", true).isValid()) {
            return moment(maxRentalDate).format("YYYY-MM-DD");
        } else {
            return moment().add(parseInt(maxRentalDate), 'days').format("YYYY-MM-DD");
        }
    }

    let validationSchema = Yup.object().shape({
        days: Yup.number()
            .required(t('Number of Days is required')),
        acceptTerms: Yup.bool()
            .oneOf([true], t('reservation.agreeError')),
    });

    async function stripe_redir(lockerType, reservationId) {

        const stripe = await stripePromise;

        // Call the backend to create the Checkout Session
        const response = await fetchWrapper.post('/create-checkout-session',
            {
                lockerType: lockerType,
                reservation_id: reservationId
            }
        );

        const session = await response;

        // When the customer clicks on the button, redirect them to Checkout.
        const result = await stripe.redirectToCheckout({
            sessionId: session.id,
        });

        if (result.error) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
            alertService.error(result.error.message);
        }
    }

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        accountService.addReservation(fields)
            .then((data) => {
                stripe_redir(fields.lockerType, data.id);
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });

    }

    const handleClose = () => {
        setShowTerms(false);
    };
    const handleShow = () => {
        setShowTerms(true);
    };

    const handleDaysChange = (e) => {
        setDays(e.target.value);
    };

    const end_date_and_time = () => {
        var end_time_string;
        if (typeof (accountService.configValue['eobDisplay']) !== 'undefined') {
            var d = new Date(moment(reservation.endDate).format('YYYY-MM-DD') + " " + accountService.configValue['eobDisplay']);
            end_time_string = d.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
            
        } else {

            end_time_string = " end of business day";
        }
        // end date in UI is the last day of rental at closing time but end date in db is day after?
        // i.e. a 2 day rental starting today ends tomorrow at close so we add 1 to today not the number of days rented
        var end_date = moment(reservation.endDate).add(days - 1, 'days').format('YYYY/MM/DD');
        return end_date + " at " + end_time_string;
    }
        
    return (
        
        <div className="card m-3">
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize={true}>
                {({ errors, touched, isSubmitting, handleChange }) => (
                    <Form>
                        <div className="card-header">
                            <h1 className="bold-tx">{t('Extend Rental')}</h1>
                        </div>
                        <div className="card-body">
                            
                            <div className="form-row">
                                <div className="form-group col-6 ">

                                    <label className="" htmlFor="days">{t('Number of Days :')}</label>
                                    <Field
                                        as="select"
                                        name="days"
                                        onChange={(e) => { handleChange(e); handleDaysChange(e, this); }}
                                        id="days"
                                        className={'input form-control ' + (errors.days && touched.days ? ' is-invalid' : '')} >
                                        {

                                            days_array.map((val) =>
                                                <option key={val} value={val}>{val}</option>
                                            )
                                        }
                                        <ErrorMessage name="days" component="div" className="invalid-feedback" />
                                    </Field>
                                </div>
                            </div>
                            {reservation &&
                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>Rental will end: {end_date_and_time()}</label>
                                    </div>
                                </div>
                            }
                            <div className="form-row rent-agree-marg">
                                <div className="form-group form-check col-6" style={{ 'paddingLeft': 30 + 'px', 'paddingRight': '0' }} >
                                    <Field type="checkbox" name="acceptTerms" id="acceptTerms" className={'form-check-input ' + (errors.acceptTerms && touched.acceptTerms ? ' is-invalid' : '')} />
                                    <label htmlFor="acceptTerms" className="form-check-label">{t('reservations.agree')} <Link to="#" onClick={handleShow} >{t('Rental Agreement')}.</Link>
                                        <br />
                                        {t('reservations.salesFinal')}
                                    </label>
                                    <ErrorMessage name="acceptTerms" component="div" className="invalid-feedback" />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <button type="submit" id="toPayment" disabled={isSubmitting} className="btn btn-primary">
                                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                        {t('Step 2 - Payment')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h3 className="card-header cust-footer">
                                <Link to="../reservations/active" className="btn btn-link">{t('Cancel')}</Link>
                            </h3>
                        </div>
                    </Form>
                )}
            </Formik>
            <TermsModal show={showTerms} onHide={handleClose} />
        </div>
        
    );
}

export { ExtendReservation }; 